import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseDataService } from './base.data.service';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import {
  ValidateCarryoverAddressRequest,
  ValidateCarryoverAddressResponse,
} from '../interfaces/carryover/validate-carryover-address';

@Injectable({
  providedIn: 'root',
})
export class CarryoverService extends BaseDataService {
  public url = '/api/carryover';

  constructor(public http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  public async validateCarryoverAddress(
    request: ValidateCarryoverAddressRequest,
  ): Promise<ValidateCarryoverAddressResponse> {
    return await this.http
      .post<ValidateCarryoverAddressResponse>(`${this.url}/validate-address`, request)
      .toPromise();
  }
}
